import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { Trophy, Play, Settings, Plus } from 'lucide-react';
import Button from '../components/ui/Button';

const HomePage = () => {
  const navigate = useNavigate();
  const { tournament } = useAppContext();
  
  // Redirect to active tournament if one exists
  useEffect(() => {
    if (tournament) {
      navigate('/schedule');
    }
  }, [tournament, navigate]);
  
  return (
    <div 
      className="flex flex-col items-center justify-center min-h-screen p-4 text-white relative" 
      style={{
        backgroundImage: "url('/screenshots/bg.jpg')",
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60 z-0"></div>

      {/* Content (needs to be above overlay) */}
      <div className="w-full max-w-md flex flex-col items-center relative z-10">
        {/* Logo & App Name */}
        <div className="mb-8 flex flex-col items-center">
          <Trophy size={64} className="mb-4" />
          <h1 className="text-4xl font-bold text-center">Soccer Tournament Manager</h1>
          <p className="text-lg opacity-80 mt-2 text-center">Create, manage, and run live soccer tournaments</p>
        </div>
        
        {/* Main Actions */}
        <div className="w-full grid gap-4 mb-6">
          <Button 
            primary 
            icon={<Plus size={20} />} 
            onClick={() => navigate('/setup')}
            className="h-14 text-lg"
          >
            Create New Tournament
          </Button>
          
          <Button 
            secondary 
            icon={<Play size={20} />} 
            onClick={() => navigate('/schedule')}
            className="h-14 text-lg"
            disabled={!tournament}
          >
            Continue Tournament
          </Button>
        </div>
        
        {/* Secondary Actions */}
        <Button 
          tertiary 
          icon={<Settings size={18} />} 
          onClick={() => navigate('/settings')}
          className="mt-8"
        >
          Settings
        </Button>

        {/* Footer text */}
        <p className="mt-10 text-sm opacity-70">
          Game on. Your pitch, your rules.
        </p>
      </div>
    </div>
  );
};

export default HomePage;
